var _path, _path2, _path3, _ellipse, _ellipse2, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisapproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 106,
    viewBox: "0 0 85 106",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.979 1.28711H11.3958C8.63866 1.28711 5.99445 2.37531 4.04486 4.31232C2.09527 6.24933 1 8.87648 1 11.6158V94.2456C1 96.985 2.09527 99.6121 4.04486 101.549C5.99445 103.486 8.63866 104.574 11.3958 104.574H73.7706C76.5277 104.574 79.1719 103.486 81.1215 101.549C83.0711 99.6121 84.1663 96.985 84.1663 94.2456V32.2733L52.979 1.28711Z",
    fill: "#F1F5FA",
    stroke: "#CCD2E0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9766 1.28711V30.2733C52.9766 31.3778 53.872 32.2733 54.9766 32.2733H84.1639",
    fill: "#CCD2E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9766 1.28711V30.2733C52.9766 31.3778 53.872 32.2733 54.9766 32.2733H84.1639",
    stroke: "#CCD2E0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.0738,
    cy: 52.7621,
    rx: 3.07377,
    ry: 3.04918,
    fill: "#8894AC"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.4175,
    cy: 52.7621,
    rx: 3.07377,
    ry: 3.04918,
    fill: "#8894AC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 69.2489C35.5 66.2488 44.86 62.3422 53.5 62.7412",
    stroke: "#5D6A86",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisapproved);
export default __webpack_public_path__ + "static/media/disapproved.1354d446047b064a5f22e82f9f1e333c.svg";
export { ForwardRef as ReactComponent };